import React from "react";
import { api } from "../../lib/api";
import { useFetch, act } from "../../lib/useFetch";
import { ORDER_STATUS_LABELS } from "../../lib/constants";
import { rub, fmtDateTime } from "../../lib/format";
import AdminDialog from "./AdminDialog";
import { Trash2 } from "lucide-react";

function Section({ title, items, render, onDelete, testid }) {
  return (
    <div>
      <div className="text-xs tracking-widest uppercase text-gold mb-2">{title} ({items.length})</div>
      {items.length === 0 ? <p className="text-sm text-gray-500">Нет</p> : (
        <div className="space-y-2">
          {items.map((it) => (
            <div key={it.id} className="glass-cyan rounded-lg p-3 flex items-center gap-3 text-sm" data-testid={`${testid}-${it.id}`}>
              <div className="flex-1 min-w-0 flex flex-wrap items-center gap-3">{render(it)}</div>
              <span className="text-xs text-gray-500 whitespace-nowrap">{fmtDateTime(it.created_at)}</span>
              {onDelete && <button onClick={() => onDelete(it.id)} className="btn-outline !py-1 !px-2" title="Удалить" data-testid={`${testid}-delete-${it.id}`}><Trash2 size={12} /></button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function UserStatsDialog({ user, canDelete, onClose, onChanged }) {
  const [data, reload] = useFetch(`/admin/users/${user.id}/stats`);
  const del = async (kind, id) => {
    if (!window.confirm(kind === "orders" ? "Удалить заказ?" : "Удалить отзыв?")) return;
    await act(api.delete(`/admin/${kind}/${id}`), "Удалено");
    reload();
    onChanged();
  };
  const t = data?.totals;
  const cards = t ? [["Заказов", t.orders], ["Оказано", t.done], ["Сумма оказанных", rub(t.spent)], ["Средняя оценка", t.avg_rating ?? "—"]] : [];

  return (
    <AdminDialog wide title={`📊 ${user.name}`} description={user.email} onClose={onClose} testid="user-stats-dialog">
      {!data ? <p className="text-gray-400">Загрузка…</p> : (
        <div className="space-y-5">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {cards.map(([l, v]) => (
              <div key={l} className="glass rounded-xl p-3">
                <div className="text-gold font-heading text-xl font-bold">{v}</div>
                <div className="text-xs text-gray-400">{l}</div>
              </div>
            ))}
          </div>
          <Section title="🗑️ Заказы" items={data.orders} testid="user-stats-order" onDelete={canDelete ? (id) => del("orders", id) : null}
            render={(o) => <><span>{o.service_title}</span><span className="text-gold font-mono">{rub(o.price)}</span><span className="text-xs">{ORDER_STATUS_LABELS[o.status]}</span><span className="chip">{o.language}</span></>} />
          <Section title="🗑️ Отзывы" items={data.reviews} testid="user-stats-review" onDelete={(id) => del("reviews", id)}
            render={(r) => <><span className="text-gold">{"★".repeat(r.rating)}</span><span className="truncate max-w-[360px]">{r.text}</span></>} />
        </div>
      )}
    </AdminDialog>
  );
}
